
import $ from "jquery";
import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import Add from './add';
import Title from '../title';
import Loading from '../loading';
import Server from '../../functions/server';



class ExpenseDetailss extends React.Component {

  state = {
    expenseDetails: [], fromDate: this.getFormatedDate(new Date(), 'fromDate'),
    toDate: this.getFormatedDate(new Date(), 'toDate')
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  handleChange = (type) => (e, {value}) => this.setState({ [type]: value }) 

  render() {
    return (
      <div>
        <Title title={'Expense Details'} openDrawer={this.props.openDrawer}/>
        <div style={{margin: 10, display: 'flex'}}>
          <div>
              <input type="date" id="date" value={this.state.fromDate}
              style={{height: 35 }} onChange={this.handleChange('fromDate')} />
          </div>
          <Add />
          <div>
              <input type="date" id="date" value={this.state.toDate}
              style={{height: 35 }} onChange={this.handleChange('toDate')} />
          </div>
        </div>
      </div>
    );
  }
}

export default ExpenseDetailss;
